import FinancialsTables from 'pages/Financials/components/FinancialsTables';

export default FinancialsTables;
